import { useEffect, useState } from 'react';
import styles from '../styles/compute.module.scss';
import Arrow from '../svgs/arrow.svg';
import Image from 'next/image';

const Slider = ({ innerWidth, items, className }) => {
    const [width, setWidth] = useState();
    const [currentSlide, setCurrentSlide] = useState({
        value: 0, direction: null
    });
    const [swipe, setSwipe] = useState({
        startX: 0,
        startY: 0,
        startTime: 0
    });

    const checkWidth = (width) => {
        if (width < 460) {
            return 148;
        }
        if (width < 640 && width >= 460) {
            return 312;
        }
        if (width < 830 && width >= 640) {
            return 476;
        }
        if (width < 1014 && width >= 830) {
            return 640;
        }
        if (width < 1090 && width >= 1014) {
            return 804;
        }
        if (width >= 1090) {
            return 968;
        }
    };

    useEffect(() => {
        setWidth(checkWidth(innerWidth || window.innerWidth));
    }, [innerWidth]);

    const moveSlider = (direction) => {
        setCurrentSlide(prevState => direction === 'back' ? {
            value: prevState.value === 0 ? 0 : prevState.value - 1,
            direction
        } : {
            value: prevState.value + 1,
            direction
        });
    };

    const changeItem = (action) => {
        let content = document.querySelector(`.${className}`);
        if (action === 'back') {
            content.insertBefore(content.children[items.length - 1].cloneNode(true), content.children[0]);
            content.children[items.length].remove();
        }
        if (action === 'forward') {
            content.appendChild(content.children[0].cloneNode(true));
            content.children[0].remove();
        }
    };

    useEffect(() => {
        changeItem(currentSlide.direction);
    }, [currentSlide]);

    const onTouchStart = (e) => {
        const obj = e.changedTouches[0];
        setSwipe({ startX: obj.pageX, startY: obj.pageY, startTime: new Date().getTime() });
    };

    const onTouchEnd = (e) => {
        const touchobj = e.changedTouches[0];
        const dist = touchobj.pageX - swipe.startX;
        const elapsedTime = new Date().getTime() - swipe.startTime;
        const swiper = (elapsedTime <= 400 && Math.abs(dist) >= 50 && Math.abs(touchobj.pageY - swipe.startY) <= 300);
        if (swiper && dist > 0) {
          changeItem('back');
        }
        if (swiper && dist < 0) {
          changeItem('forward');
        }
    };

    return (
        <div className={'flex ' + styles.slider} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            <div className={styles.left} style={{ display: width <= 804 ? 'block' : 'none' }}>
                <Image src={Arrow} onClick={() => moveSlider('back')} alt="Arrow back" />
            </div>
            {/* <Arrow style={{ display: width <= 804 ? 'block' : 'none' }} onClick={() => moveSlider('back')} /> */}
            <div style={{width: `${width}px` }} className={styles.wrapper}>
                <div className={`flex ${className} ${styles.content}`}>
                    { items.map((item, key) => <div key={key} className={`flex col ${styles.item}`}>
                        <img src={item.img} alt="" />
                        <p>{item.name}</p>
                    </div>) }
                </div>
            </div>
            <div className={styles.right} style={{ display: width <= 804 ? 'block' : 'none' }}>
                <Image src={Arrow} onClick={() => moveSlider('forward')} alt="Arrow forward" />
            </div>
            {/* <Arrow style={{ display: width <= 804 ? 'block' : 'none' }} className={styles.right} onClick={() => moveSlider('forward')} /> */}
        </div>
    )
};

export default Slider;
